import React, { useRef, forwardRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import zhCN from "date-fns/locale/zh-CN";
import "react-datepicker/dist/react-datepicker.css";
import { color } from "../../styles/color";
import styled from "@emotion/styled";
import type { SetState } from "../../client_types";

registerLocale("zh", zhCN);

const StyledDateOutter = styled.div`
  .dateOutter {
    width: 100%;
    .customInput {
      border: 1px solid ${color.default};
      padding: 0.2rem 0.5rem;
      border-radius: 0.3rem;
      text-align: left;
    }
    .react-datepicker__input-container input:not([type="range"]) {
      width: 100%;
      border-radius: 0.3rem;
      padding: 0.2rem 0.3rem;
      color: ${color.default};
      &:focus-visible {
        outline: none;
      }
    }
    .react-datepicker__close-icon {
      &:after {
        background-color: ${color.markedSecondary};
        position: absolute;
        right: 0.5rem;
        top: 50%;
        transform: translate(0, -50%);
      }
    }
    .react-datepicker-popper[data-placement^="bottom"] {
      z-index: 10;
    }
    .react-datepicker {
      font-size: 1.125em;
      border-radius: 0.5rem;
      border-color: transparent;
      box-shadow: 4px 14px 10px 8px ${color.borderGray};
    }
    .react-datepicker__header {
      background-color: white;
    }
    .react-datepicker__navigation {
      top: 0.5rem;
    }
    .react-datepicker__navigation--previous {
      border-right-color: #ccc;
      left: 1em;
    }
    .react-datepicker__navigation--next {
      border-left-color: #ccc;
      right: 1em;
    }
    .react-datepicker__day--selected,
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__day--in-range,
    .react-datepicker__day--keyboard-selected {
      background-color: ${color.markedSecondary};
    }
    .react-datepicker__today-button {
      color: white;
      background: ${color.markedSecondary};
      border: none;
      padding: 0.5rem 0;
      border-bottom-left-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
    .react-datepicker__month {
      margin: 0.7rem;
    }
    .react-datepicker__day-name,
    .react-datepicker__day,
    .react-datepicker__time-name {
      width: 2rem;
      line-height: 2rem;
    }
  }
`;

interface ReadonlyInputProps {
  value: any;
  onClick: (e?: React.MouseEvent) => void;
}
const ReadonlyInput = forwardRef(
  ({ value, onClick }: ReadonlyInputProps, ref: any) => (
    <div
      className="customInput"
      onClick={onClick}
      ref={ref}
      style={{ color: value ? "black" : `${color.default}` }}
    >
      {value ? value : "起始日期 - 结束日期"}
    </div>
  )
);

interface IProps {
  startDate: Date | null;
  endDate: Date | null;
  setDateRange: SetState<[Date | null, Date | null]>;
}
const TimeSelector = ({ startDate, endDate, setDateRange }: IProps) => {
  const inputRef = useRef();
  return (
    <StyledDateOutter>
      <span className="dateOutter">
        <DatePicker
          selectsRange={true}
          startDate={startDate}
          endDate={endDate}
          onChange={(update) => setDateRange(update)}
          fixedHeight
          minDate={startDate}
          maxDate={new Date()}
          dateFormat="yyyy-MM-dd"
          showPopperArrow={false}
          locale="zh"
          todayButton="今日"
          ref={inputRef as any}
          customInput={
            <ReadonlyInput
              value=""
              onClick={() => console.log("placeholder")}
            />
          }
          onInputClick={() => setDateRange([null, null])}
        />
      </span>
    </StyledDateOutter>
  );
};

export default TimeSelector;
